import { render } from "./KamranComments.vue?vue&type=template&id=30ac3240&scoped=true"
import script from "./KamranComments.vue?vue&type=script&lang=js"
export * from "./KamranComments.vue?vue&type=script&lang=js"

import "./KamranComments.vue?vue&type=style&index=0&id=30ac3240&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ac3240"]])

export default __exports__